import React from 'react';
import Helmet from 'react-helmet';
import { useLocation } from 'react-router-dom';

const tabNamesByPath: { [key: string]: string } = {
  '/login': 'Bejelentkezés',
  '/profil/szemelyesadatok': 'Saját adatok',
  '/kapcsolat': 'Kapcsolat',
  '/profil/ertesitesek': 'Értesítések',
  '/profil/beallitasok/belepesi-adatok': 'Belépési adatok',
  '/profil/beallitasok/kilepesi-adatok': 'Kilépési adatok',
  '/profil/beallitasok/jelszo-modositas': 'Jelszó módosítás',
  '/profil/beallitasok': 'Beállítások',
  '/profil': 'Profil',
  '/uzenetek': 'Üzenetek',
  '/megbizasok/tozsdei': 'Tőzsdei megbízás',
  '/megbizasok/tozsdei/uj': 'Új tőzsdei megbízás',
  '/megbizasok/tozsdei/:id': 'Tőzsdei megbízás',
  '/megbizasok/befektetesijegy': 'Befektetési jegy megbízás',
  '/megbizasok/befektetesijegy/:id': 'Befektetési jegy megbízás',
  '/rendelkezesek/penz-atvezetes': 'Pénz átvezetés',
  '/rendelkezesek/penz-atvezetes/:id': 'Pénz átvezetés',
  '/rendelkezesek/ertekpapir-atvezetes': 'Értékpapír átvezetés',
  '/rendelkezesek/ertekpapir-atvezetes/:id': 'Értékpapír átvezetés',
  '/rendelkezesek/devizakonverzio': 'Devizakonverzió',
  '/rendelkezesek/devizakonverzio/:id': 'Devizakonverzió',
  '/rendelkezesek/ertekpapir-transzfer': 'Értékpapír transzfer',
  '/rendelkezesek/ertekpapir-transzfer/:id': 'Értékpapír transzfer',
  '/atutalasok': 'Átutalások',
  '/atutalasok/:id': 'Átutalások',
  '/': 'Áttekintés',
};

const renderTitleComponent = (title: string, favIcon: string): JSX.Element => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <link id="favicon" rel="icon" href={favIcon} type="image/x-icon" />
    </Helmet>
  );
};

const pickTitle = (pathName: string, tabNames: { [key: string]: string }): string => {
  const pathKey = Object.keys(tabNames).find((key) => pathName.includes(key));
  return pathKey ? tabNames[pathKey] : 'TradeBull';
};

const BrowserTabLabel = (): JSX.Element => {
  const location = useLocation();
  const title = pickTitle(location.pathname, tabNamesByPath);

  return renderTitleComponent(title, 'favicon.ico');
};

export default BrowserTabLabel;
